import { render, staticRenderFns } from "./questioncomment.vue?vue&type=template&id=260e8ae8"
import script from "./questioncomment.vue?vue&type=script&lang=js"
export * from "./questioncomment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports